import classNames from 'classnames';
import React from 'react';
import { ButtonProps } from '../../types/components/button';
import './Button.css';

const CircleButton: React.FC<ButtonProps> = ({ onClick, label, small, leftSpace, rightSpace, bold, color, fullWidth, disabled }) => {
    return (
        <button 
          onClick={onClick}
          disabled={disabled}
          className={
            classNames(
                'circle-button', 
                { 
                    'small': small, 
                    'medium': !small,
                    'margin-left': leftSpace,
                    'mergin-right': rightSpace,
                    'bold': bold,
                    [color??'primary' as string]: color??'primary',
                    'full-width': fullWidth
                }
            )
          }
        >
            {label}
        </button>
    );
};

export default CircleButton;
